import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const accountManagementAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ManageUsers],
  restrictedBannersAllowed: true,
}
